export default __webpack_public_path__ + "static/media/snr.86309143.mp3";